var _defs, _rect, _polygon, _polygon2, _polygon3, _rect2, _circle, _rect3, _circle2, _circle3, _line, _line2, _line3, _circle4, _circle5, _line4, _line5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgPrototype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "= 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "Pattern",
    x: 0,
    y: 0,
    width: 0.25,
    height: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    fill: "#50501F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 50,
    height: 50,
    fill: "#50501F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 50,
    height: 50,
    fill: "#C54438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 50,
    height: 50,
    fill: "#C54438"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#Pattern)",
    width: 400,
    height: 400
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "200,120 60,300 340,300",
    fill: "#204316"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "200,60 100,200 300,200",
    fill: "#2E5C21"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "200,0 140,100 260,100",
    fill: "#428330"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 300,
    height: 70,
    width: 60,
    fill: "#6D2C23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 22,
    r: 3,
    fill: "none",
    stroke: "#F3CB8B",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 25,
    height: 4,
    width: 12,
    fill: "#F3CB8B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 38,
    r: 10,
    fill: "pink",
    stroke: "red",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 10,
    fill: "#B78359"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 175,
    y1: 165,
    x2: 195,
    y2: 165,
    stroke: "#B78359",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 165,
    x2: 175,
    y2: 185,
    stroke: "#B78359",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 165,
    x2: 195,
    y2: 185,
    stroke: "#B78359",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 150,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 150,
    r: 2,
    fill: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 183,
    y1: 155,
    x2: 187,
    y2: 155,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 183,
    y1: 155,
    x2: 187,
    y2: 155,
    stroke: "#B78359",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 165,
    r: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 172,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPrototype);
export default __webpack_public_path__ + "static/media/svg_prototype.ec5cd559748cc47b8516bc6587a64d0e.svg";
export { ForwardRef as ReactComponent };